import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import SearchBox from "@atoms/SearchBox";
import type { IFilter, IFilterFaqProps } from "@containers/FAQ/interface";
import Text from "@ds/components/Text";
import useResponsive from "@helpers/useResponsive";
import useStyles from "@containers/FAQ/styles";
import Link from "next/link";

const FilterFaq = (props: IFilterFaqProps) => {
  const { filterProps, filterList, router, search, isGetSupport } = props;
  const { t } = useTranslation("faq");
  const isMD = useResponsive("md");
  const classes = useStyles({ isMD });

  const renderCategoryFilter = !search && Object.keys(router?.query || {}).length === 0 && (
    <Box mx={isMD ? 0 : 1} sx={{ textAlign: "center" }}>
      <Box
        display={isMD ? "grid" : "flex"}
        gridTemplateColumns="repeat(2,1fr)"
        flexWrap="wrap"
        flexDirection="row"
        mb={isMD ? 4 : 3}
        sx={{
          gap: isMD ? 2 : "16px",
        }}
      >
        {filterList?.map((el: IFilter, idx: number) => (
          <Link href={`/bantuan/${el.path}`} key={idx}>

            <ToggleButton
              className={classes?.btnToggle}
              value={el.valueBtn as string}
              fullWidth={true}
              sx={{
                padding: isMD ? "12px 16px" : undefined,
                width: isMD ? "100%" : "197px",
              }}
            >
              <Box className={classes?.btnToggleContent}>
                {el.icon}
                <Text
                  color="general-main"
                  align="left"
                  sx={{ fontSize: "14px", lineHeight: isMD ? "19px" : undefined }}
                >
                  {el.title}
                </Text>
              </Box>
            </ToggleButton>

          </Link>
        ))}
      </Box>
    </Box>
  );

  return (
    <Box>
      {!isGetSupport && (
        <Box mx={isMD ? 1 : 0} mt={isMD ? 0 : 6}>
          <SearchBox
            {...filterProps.search}
            value={search}
            placeholder={t("placeholder")}
            css={{
              backgroundColor: "#FFF",
              border: "1px solid #DEE3ED",
              height: "36px",
            }}
          />
        </Box>
      )}
      {!search && Object.keys(router?.query || "").length === 0 && (
        <Box my="16px" mt={isMD ? "25px" : undefined} mx={isMD ? 0 : 1}>
          <Text
            variant={isMD ? "body1" : "h2"}
            weight="700"
            sx={{ fontSize: isMD ? "16px" : "20px" }}
          >
            {t("topics.title")}
          </Text>
        </Box>
      )}
      {renderCategoryFilter}
    </Box>
  );
};

export default FilterFaq;
